import React from "react";
import { Select } from "antd";
import {
  INVOICE_TEMPLATES,
  PAGE_SIZE_OPTIONS,
  ORIENTATION_OPTIONS,
} from "../../Constant";
import { TemplatesTypes, PageSizeType, PageOrientation } from "../templates";

interface PrintConfigSelectorProps {
  template?: TemplatesTypes;
  pageSize: PageSizeType;
  orientation: PageOrientation;
  onChangeTemplate?: (value: TemplatesTypes) => void;
  onChangePageSize: (value: PageSizeType) => void;
  onChangeOrientation: (value: PageOrientation) => void;
  className?: string;
  size?: "small" | "middle" | "large";
  showLabels?: boolean;
}

export const PrintConfigSelector: React.FC<PrintConfigSelectorProps> = ({
  template,
  pageSize,
  orientation,
  onChangeTemplate,
  onChangePageSize,
  onChangeOrientation,
  className,
  size = "middle",
  showLabels = false,
}) => {
  return (
    <div className={className || "flex gap-5 justify-center mb-3"}>
      {template && onChangeTemplate && (
        <div className="flex items-center gap-2">
          {showLabels && (
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
              Template
            </span>
          )}
          <Select
            size={size}
            className="w-32"
            value={template}
            onChange={onChangeTemplate}
            options={INVOICE_TEMPLATES}
          />
        </div>
      )}
      <div className="flex items-center gap-2">
        {showLabels && (
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
            Page Size
          </span>
        )}
        <Select
          size={size}
          className="w-32"
          value={pageSize}
          onChange={onChangePageSize}
          options={PAGE_SIZE_OPTIONS}
        />
      </div>
      <div className="flex items-center gap-2">
        {showLabels && (
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
            Orientation
          </span>
        )}
        <Select
          size={size}
          className="w-32"
          value={orientation}
          onChange={onChangeOrientation}
          options={ORIENTATION_OPTIONS}
        />
      </div>
    </div>
  );
};
